module.exports = __webpack_public_path__ + "UX42.png?2860820c82007452e55c1b98236efbdb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX42.png
// module id = 93
// module chunks = 0